import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ARInvoice } from '../../models/ar-invoice.model';
import { ContractService } from 'src/app/services/contract.service';
import { finalize } from 'rxjs/operators';
import { PdfViewComponent } from '../pdf-view/pdf-view.component';

@Component({
    selector: 'app-invoice-payments',
    templateUrl: './invoice-payments.component.html',
    styleUrls: ['./invoice-payments.component.scss'],
    standalone: false
})
export class InvoicePaymentsComponent {

  @Input() internId: string = '';
  @Input() internName: string = '';

  paidInvoices: ARInvoice[] | undefined = undefined;
  openInvoices: ARInvoice[] | undefined = undefined;
  loadingPdf = false;

  constructor(
    private contractService: ContractService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadOpenInvoices();
    this.loadPaidInvoices();
  }

  loadPaidInvoices(): void {
    this.contractService.GetInvoicesByInternAndStatus(this.internId, 'Paid').subscribe({
      next: (invoices) => {
        this.paidInvoices = invoices;
      },
      error: (err) => {
        console.error('Failed to load paid invoices:', err);
      }
    });
  }

  loadOpenInvoices(): void {
    this.contractService.GetInvoicesByInternAndStatus(this.internId, 'Posted').subscribe({
      next: (invoices) => {
        this.openInvoices = invoices;
      },
      error: (err) => {
        console.error('Failed to load open invoices:', err);
      }
    });
  }

  onSelectedInvoiceRecordNoChange(recordNo: string): void {
    this.loadingPdf = true;
    this.contractService.getInvoicePdfById(recordNo)
      .pipe(finalize(() => {
        this.loadingPdf = false;
      })).subscribe({
        next: (blob: Blob) => {
          this.dialog.open(PdfViewComponent, { data: blob, width: '50%', height: '85%' });
        },
        error: (err) => {
          console.error('Failed to load invoice PDF:', err);
        }
      });
  }

}
